import React from "react";
import { Stack, Text, TooltipHost, Icon } from "@fluentui/react";
import { CustomMetricsCard } from "../../../../SharedComponents/CustomMetricsCard";
import { ICatalystEngagementStatus } from "../../../../interfaces/Catalyst.interfaces";
import { CatalystTabTooltips } from "../../Common/HealthView.constants";

export interface CatalystEngagementStatusProps {
  data?: ICatalystEngagementStatus[];
  onStatusClick?: (statusLabel: string) => void;
  isStatusClickable?: (statusLabel: string) => boolean;
}

const COLOR_PALETTE = [
  "#0078D4",
  "#00A36C",
  "#8764B8",
  "#038387",
  "#486860",
  "#CA5010",
  "#4F6BED",
  "#E3008C",
];

export const CatalystEngagementStatus: React.FC<CatalystEngagementStatusProps> = ({
  data,
  onStatusClick,
  isStatusClickable,
}) => {
  const getStatusClickHandler = (statusLabel: string) => {
    if (!onStatusClick || (isStatusClickable && !isStatusClickable(statusLabel))) {
      return undefined;
    }
    return () => onStatusClick(statusLabel);
  };

  const items = [...(data || [])].sort((a, b) => a.sortOrder - b.sortOrder);
  const midpoint = Math.ceil(items.length / 2);
  const topRow = items.slice(0, midpoint);
  const bottomRow = items.slice(midpoint);

  return (
    <Stack tokens={{ childrenGap: 8 }} styles={{ root: { flex: 1 } }}>
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
        <Text variant="mediumPlus" styles={{ root: { fontWeight: 600 } }}>
          Catalyst Engagement Status
        </Text>
        <TooltipHost content={CatalystTabTooltips.EngagementHeader}>
          <Icon iconName="Info" styles={{ root: { fontSize: 14, color: "#605E5C", cursor: "pointer" } }} />
        </TooltipHost>
      </Stack>
      <Stack tokens={{ childrenGap: 10 }} styles={{ root: { flex: 1 } }}>
        <Stack horizontal tokens={{ childrenGap: 10 }} wrap>
          {topRow.map((item, index) => (
            <Stack.Item grow key={item.catalystEngagementStatus}>
              <CustomMetricsCard
                title={item.catalystEngagementStatus}
                description={
                  CatalystTabTooltips.EngagementStatuses[item.catalystEngagementStatus] ??
                  `Count for ${item.catalystEngagementStatus}`
                }
                currentValue={item.tenantCount}
                color={COLOR_PALETTE[index % COLOR_PALETTE.length]}
                disableSparkline={true}
                onClick={getStatusClickHandler(item.catalystEngagementStatus)}
              />
            </Stack.Item>
          ))}
        </Stack>
        {bottomRow.length > 0 && (
          <Stack horizontal tokens={{ childrenGap: 10 }} wrap>
            {bottomRow.map((item, index) => (
              <Stack.Item grow key={item.catalystEngagementStatus}>
                <CustomMetricsCard
                  title={item.catalystEngagementStatus}
                  description={
                    CatalystTabTooltips.EngagementStatuses[item.catalystEngagementStatus] ??
                    `Count for ${item.catalystEngagementStatus}`
                  }
                  currentValue={item.tenantCount}
                  color={COLOR_PALETTE[(midpoint + index) % COLOR_PALETTE.length]}
                  disableSparkline={true}
                  onClick={getStatusClickHandler(item.catalystEngagementStatus)}
                />
              </Stack.Item>
            ))}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
